import { Component, Inject, OnInit } from '@angular/core';
import { ScheduleService } from '../schedule.service';
import { empty, Observable } from 'rxjs';
import { tap, switchMap, debounceTime } from 'rxjs/operators';
import {  MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessagerComponent } from '../../messager/messager/messager.component';
import { LoggingService } from '../../utils/logging.service';
import { AuthService } from '../../auth.service';
import { FormControl, FormGroup } from '@angular/forms';
import { LocationService } from '../../location/location.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { BANK_HOLIDAYS, BARRIS_EMPLOYEE_ID, BARRIS_UNAVAILABLE_DAYS,
  BARRIS_UNAVAILABLE_TITLE, BARRIS_UNAVAILABLE_MSG } from '../../utils/constants';
import { WarningPopupComponent } from '../../utils/warning-popup/warning-popup.component';
import * as moment from 'moment';
import { convert_schedule_date_to_string_date } from 'src/app/utils/helpers';



@Component({
  selector: 'app-batch-edit',
  templateUrl: './batchEdit.component.html',
  styleUrls: ['../../location/location.component.css']
})
export class BatchEditComponent implements OnInit {


  camData: any;
  employee$: Observable<any[]>;
  employee_name: '';
  nameObjs : [];
  employee_id : number;
  usernamee;
  user: any;
  role: any;
  employeeID: any;
  showWarningDetails: boolean = false;
  warningsToShow: [];
  timeOffEmployees: any[] = [];
  ptoWarning: string = '';
  selectedBambooId: any;

  // The dialog is opened with { items, mandatoryJobIds, isScheduler }; `items` is
  // the job-id list every batch endpoint takes.
  jobIds: any[] = this.data.items || [];
  // Jobs tagged 'Mandatory Job' -- only scheduling may move them to another date.
  // Batch technician changes are deliberately not restricted.
  mandatoryJobIds: any[] = this.data.mandatoryJobIds || [];
  isScheduler: boolean = this.data.isScheduler === true;
  // { job_id, schedule_date: 'YYYY-MM-DD', technitian } for the selected jobs.
  batchJobs: any[] = [];



  constructor( public dialogRef: MatDialogRef<BatchEditComponent>, public service: LocationService, @Inject(MAT_DIALOG_DATA) public data: any, public scheduleService: ScheduleService, public logger: LoggingService, public messager: MessagerComponent, public auth: AuthService, public dialog: MatDialog) { }


  form = new FormGroup({
    technitian: new FormControl(),
    schedule_date: new FormControl()
  });






  ngOnInit(): void {

    this.employee$ = this.form.get('technitian').valueChanges.pipe(
      debounceTime(400),
      switchMap(value =>
        value.length > 0 ? this.service.getEmployeesDropdown(value as string) : empty()
        .pipe(
          tap((res) => {
          }),
          )
      )
    );

    this.auth.userProfile$.subscribe(
      (profile) => {

        this.user = profile;
        this.role = profile['https://rhv2.com.role'];
        this.employeeID = this.auth.getEmployeeId();
        //console.log('Empid', this.employeeID);
        this.usernamee = this.user ? this.user.nickname.charAt(0).toUpperCase() + this.user.nickname.slice(1) : '';

      });

    //get street addresses
    this.scheduleService.getBatchLocations(this.jobIds).subscribe(
      res => {
        this.nameObjs = res.Data;
      }, err => {
      }
    )

    //dates and technicians, so picking Barris or a Mon/Wed date can warn
    this.scheduleService.getBatchJobDates(this.jobIds).subscribe(
      res => {
        this.batchJobs = (res && res.Data) ? res.Data : [];
        // The fetch can land after an early selection; only re-check if one was made.
        if(this.employee_id || this.form.get('schedule_date').value){
          this.checkBarrisAvailability();
        }
      }, err => {
      }
    )

    //see who's out, so picking a technician can warn the same way the single-job dialog does
    this.service.getTimeOff().subscribe(
      res => {
        this.timeOffEmployees = (res && res.Data ? res.Data : []).map(item => {
          return {
            employeeId: item.employeeId,
            startDate: item.start,
            name: item.name,
            endDate: item.end
          };
        });
      }, err => {
      }
    )
  }

  resetEmployeeName(data){
      data.job.employee_name = '';
      data.job.technitian = 0;
  }

  setDate(schedule_date){

    // Jobs tagged 'Mandatory Job' are dropped from the batch rather than failing the
    // whole run, so the rest of the selection still moves.
    let idsToMove = this.jobIds;
    let skipped = 0;

    if(!this.isScheduler && this.mandatoryJobIds.length > 0){
      idsToMove = this.jobIds.filter(id => !this.mandatoryJobIds.includes(id));
      skipped = this.jobIds.length - idsToMove.length;

      if(idsToMove.length === 0){
        this.messager.openSnackBar(
          'These jobs are tagged "Mandatory Job" and can only be moved by scheduling. Please contact scheduling.',
          'Close', 'errorAlert');
        this.logger.warn(this.usernamee + ' was blocked from batch moving mandatory jobs: ' + this.mandatoryJobIds);
        return;
      }
    }

    this.scheduleService.setBatchDate(idsToMove, schedule_date ).subscribe(
      res => {
        this.logger.info(this.usernamee + ' successfully batch edited date for: '+ idsToMove);
        (res?.Trips || []).forEach(trip => {
          this.logger.info(this.usernamee + ' batch moved the TRIP with id: ' + trip.job_id + ' to ' + schedule_date
            + ' and ' + trip.moved_tasks + ' task(s) with it with location_id: ' + trip.location_id);
        });
        this.messager.openSnackBar(
          skipped > 0
            ? 'Changed the date for ' + idsToMove.length + ' job(s). ' + skipped
              + ' tagged "Mandatory Job" were skipped - contact scheduling to move those.'
            : 'Successfully changed the date!',
          skipped > 0 ? 'Close' : '', 'successAlert');
      }, err => {
        this.logger.error(this.usernamee + ' experienced error setting date: '+ err);
        this.messager.openSnackBar('Error', '', 'errorAlert');
      }
    )
  }

  setEmployee(){
    this.scheduleService.setBatchEmployee(this.jobIds, this.employee_id).subscribe(
      res => {
        this.logger.info(this.usernamee + ' successfully batch edited employee for: '+ this.jobIds);
        this.messager.openSnackBar('Successfully changed the employee!', '', 'successAlert');
      }, err => {
        this.logger.error(this.usernamee + ' experienced error batch editing employee: '+ err);
        this.messager.openSnackBar('Error setting employee.', '', 'errorAlert');
      }
    )
  }



  displayFunctionEmployee(obj: any){
    if(obj) { return obj.employee_name}
  }

  onSelectEmployee(obj: any){
    this.employee_id = obj.employee_id;
    this.selectedBambooId = obj.bamboo_id;
    this.checkEmployeeOff();
    this.checkBarrisAvailability();
    this.scheduleService.getWarningsForBatchCredentials(this.jobIds, this.employee_id).subscribe(
      res => {
        if(res.WLength > 0){
          this.showWarningDetails = true;
          this.warningsToShow = res.Warnings;
        }
      }
    )
  }

  // Warning only, never blocks the save - mirrors the single-job dialog's note.
  // With no date chosen the batch spans many dates, so any upcoming absence is
  // reported rather than an overlap against one day.
  checkEmployeeOff(){
    this.ptoWarning = '';
    if(!this.selectedBambooId){ return; }

    const timeOff = this.timeOffEmployees.find(employee => employee.employeeId === this.selectedBambooId);
    if(!timeOff){ return; }

    const date = convert_schedule_date_to_string_date(this.form.get('schedule_date'));
    if(date){
      if(date >= timeOff.startDate && date <= timeOff.endDate){
        this.ptoWarning = 'NOTE: ' + timeOff.name + ' is off from ' + timeOff.startDate + ' to ' + timeOff.endDate + '.';
      }
    } else {
      this.ptoWarning = 'NOTE: ' + timeOff.name + ' has time off from ' + timeOff.startDate + ' to ' + timeOff.endDate + '.';
    }
  }

  onSelectDate(type: string, event: MatDatepickerInputEvent<Date>){

    let date = convert_schedule_date_to_string_date(this.form.get('schedule_date'));
    if(BANK_HOLIDAYS.includes(date)){
      this.messager.openSnackBar('Cannot schedule on this date (holiday). Please select another date.', '', 'errorAlert');
      this.form.get('schedule_date').setValue('');
    }
    // The picked date is read back off the form by setDate(); there is no single
    // job object here to stash it on. (This branch used to assign `this.data.job`,
    // which is undefined -- the dialog is handed a job-id list -- so it threw and
    // the PTO check below never ran.)
    this.checkEmployeeOff();
    this.checkBarrisAvailability();

  }

  /*
   * Set Employee and Set Date are independent buttons, so three combinations can land
   * Barris on a Mon/Wed. Advisory only; neither save is blocked.
   */
  checkBarrisAvailability(): void {

    if(!this.batchJobs.length){ return; }

    const barrisPicked = Number(this.employee_id) === BARRIS_EMPLOYEE_ID;
    const picked = this.form.get('schedule_date').value;
    const pickedDay = picked && moment(picked).isValid() ? moment(picked).day() : -1;
    const pickedBad = BARRIS_UNAVAILABLE_DAYS.includes(pickedDay);

    if(!barrisPicked && !pickedBad){ return; }

    const affected = this.batchJobs.filter(job => {
      // technitian is a numeric column, so it arrives as a string.
      const isBarris = Number(job.technitian) === BARRIS_EMPLOYEE_ID;
      const own = moment(job.schedule_date, 'YYYY-MM-DD');
      const ownBad = own.isValid() && BARRIS_UNAVAILABLE_DAYS.includes(own.day());

      return (barrisPicked && ownBad) || (pickedBad && isBarris) || (barrisPicked && pickedBad);
    });

    if(!affected.length){ return; }

    this.dialog.open(WarningPopupComponent, {
      width: '500px',
      data: {
        warning_title: BARRIS_UNAVAILABLE_TITLE,
        warning_description: BARRIS_UNAVAILABLE_MSG,
        warning_sub: affected.length + ' of the ' + this.batchJobs.length
          + ' selected jobs would put Barris on a Monday or Wednesday.',
        confirmText: 'Ok',
        showCancelButton: false
      }
    });

    this.logger.warn(this.usernamee + ' was warned: batch scheduling Barris Coleman on a Monday/Wednesday for job_id: '
      + affected.map(job => job.job_id).join(', '));
  }


}
